import styled from 'styled-components'
import { device } from 'services/device'
import { Subtitle } from '../../Common/Styles/Subtitle'
import { Button } from '../../Common/Styles/Button'

export { Subtitle as Subtitle, Button as Button }

export const TextContainer = styled.div`
  width: 60%;
  text-align: left;
  padding: 0 3em 0 0;
  @media ${device.deviceL} {
    flex-direction: row;
    width: 100%;
    padding: 0;
  }
`

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media ${device.deviceL} {
    flex-direction: row;
    flex-wrap: wrap-reverse;
  }
`

export const ButtonContainer = styled.div`
  text-align: left;
  margin-bottom: 2em;
  @media ${device.deviceL} {
    text-align: center;
  }
`

export const ImageContainer = styled.div`
  width: 40%;
  padding-top: 0.7em;
  margin: auto 0;
  & img {
    height: auto;
    width: 100%;
  }
  @media ${device.deviceL} {
    width: 100%;
    padding-bottom: 2em;
  }
`
